module.exports = __webpack_public_path__ + "d8ab4c84e3b85461587dd18ff556d34d.svg";